// Pulls a date out of a search like "punch 12 may 2019" -> { date: "2019-05-12", rest: "punch" }.
const MONTHS = {
  jan: 1, january: 1, feb: 2, february: 2, mar: 3, march: 3, apr: 4, april: 4, may: 5, jun: 6, june: 6,
  jul: 7, july: 7, aug: 8, august: 8, sep: 9, sept: 9, september: 9, oct: 10, october: 10, nov: 11,
  november: 11, dec: 12, december: 12,
};
const pad = (n) => String(n).padStart(2, "0");
const valid = (y, m, d) => {
  const t = new Date(Date.UTC(y, m - 1, d));
  return t.getUTCFullYear() === y && t.getUTCMonth() === m - 1 && t.getUTCDate() === d;
};

export function parseIssueQuery(input) {
  const q = String(input || "").trim();
  const month = (s) => MONTHS[String(s).toLowerCase()];
  const tries = [
    [/\b(\d{4})-(\d{1,2})-(\d{1,2})\b/, (m) => [+m[1], +m[2], +m[3]]],
    [/\b(\d{1,2})[/.-](\d{1,2})[/.-](\d{4})\b/, (m) => [+m[3], +m[2], +m[1]]], // day first, as in Nigeria
    [/\b(\d{1,2})(?:st|nd|rd|th)?\s+([a-z]{3,9})\.?,?\s+(\d{4})\b/i, (m) => (month(m[2]) ? [+m[3], month(m[2]), +m[1]] : null)],
    [/\b([a-z]{3,9})\.?\s+(\d{1,2})(?:st|nd|rd|th)?,?\s+(\d{4})\b/i, (m) => (month(m[1]) ? [+m[3], month(m[1]), +m[2]] : null)],
  ];
  for (const [re, get] of tries) {
    const m = q.match(re);
    if (!m) continue;
    const ymd = get(m);
    if (ymd && valid(...ymd)) {
      return { date: `${ymd[0]}-${pad(ymd[1])}-${pad(ymd[2])}`, rest: q.replace(m[0], " ").replace(/\s+/g, " ").trim() };
    }
  }
  return { date: null, rest: q };
}

export const formatDay = (iso, opts = { weekday: "short", day: "numeric", month: "short", year: "numeric" }) => {
  try {
    return new Date(`${iso}T12:00:00Z`).toLocaleDateString("en-GB", { ...opts, timeZone: "UTC" });
  } catch (e) {
    return iso;
  }
};

export const todayIso = () => new Date().toISOString().slice(0, 10);
